import React, { Component } from 'react';
import { Message, Card, Button } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

class LoginError extends Component {
  constructor(props) {
    super(props);
    this.state = { errorMessage: '' };
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    this.setState({ errorMessage: params.get('message') });
  }

  render() {
    const { errorMessage } = this.state;
    const { t } = this.props;
    return (
      <Card.Group centered>
        <Card raised color="yellow" style={{ marginTop: 50 }}>
          <Card.Content>
            <Card.Header>{t('entry.login.title')}</Card.Header>
            <Card.Meta>{t('entry.login.error.info')}</Card.Meta>
          </Card.Content>
          <Card.Content textAlign="center">
            {errorMessage && <Message color="orange">{errorMessage}</Message>}
          </Card.Content>
          <Card.Content extra>
            <Button fluid primary as={Link} to="/" content={t('generic.close')} />
          </Card.Content>
        </Card>
      </Card.Group>
    );
  }
}

export default withTranslation()(LoginError);
